/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-indent */
import { Row, Col } from "react-flexbox-grid";
import { arrowBack } from "assets/svg";
import styled from "styled-components";

const StyledPageHeader = styled(Row)`
  overflow: auto;
  margin: 1em 2em;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    color: white;
    padding: 0;
    margin: 0;
  }

  img {
    width: 100%;
    max-width: 42px;
  }

  .arrow {
    filter: invert(1);
    position: absolute;
    margin: 0 1em 0 0;
    cursor: pointer;
    z-index: 99;
  }

  @media only screen and (min-width: 480px) and (max-width: 767px) {
  }

  /*--------------------------------------------------------------
   medium mobile
----------------------------------------------------------------*/

  @media only screen and (min-width: 360px) and (max-width: 479px) {
    .arrow {
      margin: -3em 1em 0 0;
      max-width: 32px;
    }
  }

  /*--------------------------------------------------------------
    small mobile
----------------------------------------------------------------*/

  @media only screen and (min-width: 320px) and (max-width: 359px) {
    .arrow {
      margin: -3em 1em 0 0;
      max-width: 32px;
    }
  }
`;

export const HeaderDashboard = ({ children, isBack = true }) => {
  return (
    <StyledPageHeader middle="xs">
      <img
        src={arrowBack}
        alt="arrow-back"
        onClick={() => window.history.back()}
        className={`arrow ${isBack ? "" : "dn"}`}
      />
      <Col md={12}>{children}</Col>
    </StyledPageHeader>
  );
};
